import React from 'react';

export default function Logo({ className = "w-6 h-6", ...props }) {
  return (
    <img 
      src="/logo/krishilogo.svg" 
      alt="HamroKrishi Bazzar" 
      className={className}
      {...props}
    />
  );
}

